import script from "./BindActivityItemTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./BindActivityItemTags.vue?vue&type=script&setup=true&lang=ts"

import "./BindActivityItemTags.vue?vue&type=style&index=0&id=039cd3b0&lang=scss"

const __exports__ = script;

export default __exports__